var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.299,
    height: 12.3,
    viewBox: "0 0 12.299 12.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58446",
    "data-name": "Group 58446",
    transform: "translate(-1292.262 -118.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M9.783.448l.6.6a1.533,1.533,0,0,1,0,2.168L6.705,6.885A1.42,1.42,0,0,1,5.7,7.3H3.863A.368.368,0,0,1,3.5,6.927l.046-1.849A1.424,1.424,0,0,1,3.959,4.1h0L7.616.448A1.536,1.536,0,0,1,9.783.448ZM8.134.967l-.3.3L9.559,2.993l.3-.3a.8.8,0,0,0,0-1.13l-.6-.6A.8.8,0,0,0,8.134.967Z",
    transform: "translate(1293.514 118.975)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_-_Outline",
    "data-name": "Combined-Shape - Outline",
    d: "M3.327-.226h2.18a.66.66,0,0,1,0,1.321H3.327a2.188,2.188,0,0,0-1.642.646A2.5,2.5,0,0,0,1.071,3.5V8.348a2.5,2.5,0,0,0,.614,1.76,2.188,2.188,0,0,0,1.642.646H8.472a2.188,2.188,0,0,0,1.643-.646,2.5,2.5,0,0,0,.614-1.76V6a.66.66,0,1,1,1.321,0V8.348a3.8,3.8,0,0,1-.987,2.692,3.484,3.484,0,0,1-2.591,1.035H3.327a3.483,3.483,0,0,1-2.59-1.035A3.8,3.8,0,0,1-.25,8.348V3.5A3.8,3.8,0,0,1,.737.809,3.483,3.483,0,0,1,3.327-.226Z",
    transform: "translate(1292.512 119)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCourse);
export default __webpack_public_path__ + "static/media/EditCourse.62d327868c261070e2e7f4ab3260ce76.svg";
export { ForwardRef as ReactComponent };